import PropTypes from 'prop-types';
import React from 'react';

const LabelValue = ({label, suffix, value}) => {
  if (value && value !== "0") {
    const suffixWithSpace = suffix ? ' ' + suffix : '';
    return (
      <li className="line-item">{label}: {value}{suffixWithSpace}</li>
    );
  } else {
    return null;
  }
}

LabelValue.propTypes = {
  label: PropTypes.string.isRequired,
  suffix: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

export default LabelValue;


// WEBPACK FOOTER //
// ./src/components/search/result/label-value.jsx